import "./App.css";

import { Link } from "react-router-dom";
import { useState } from "react";
import { WEB_APP_URL } from "./config";

function ForClients() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="bg-black text-gray-200">
      {/* Navbar */}
      <header className="bg-black bg-opacity-70 backdrop-blur-lg sticky top-0 w-full z-50 shadow-lg">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-16 w-auto"
            />
            <Link to="/" className="text-2xl font-bold gradient-text">
              FIT-MATCH
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#how-it-works" className="nav-link font-medium">
              How It Works
            </Link>
            <Link to="/our-story" className="nav-link font-medium">
              Our Story
            </Link>
            <Link to="/professionals" className="nav-link font-medium">
              Pros
            </Link>
            <Link to="/training-providers" className="nav-link font-medium">
              Providers
            </Link>
            <Link to="/communities" className="nav-link font-medium">
              Communities
            </Link>
            <Link to="/facilities" className="nav-link font-medium">
              Facilities
            </Link>
            <a
              href={WEB_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link font-medium px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"
            >
              Login
            </a>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-4 6h4"
                ></path>
              </svg>
            </button>
          </div>
        </nav>
        {/* Mobile Menu */}
        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } md:hidden bg-black bg-opacity-90 py-4`}
        >
          <Link
            to="/#how-it-works"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            How It Works
          </Link>
          <Link
            to="/our-story"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Our Story
          </Link>
          <Link
            to="/professionals"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Pros
          </Link>
          <Link
            to="/training-providers"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Providers
          </Link>
          <Link
            to="/communities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Communities
          </Link>
          <Link
            to="/facilities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Facilities
          </Link>
          <a
            href={WEB_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Login
          </a>
        </div>
      </header>

      <main className="pt-24">
        {/* Hero Section */}
        <section className="hero-bg-client py-20 md:py-32 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="container mx-auto px-6 relative z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
              Your Fitness, <span className="gradient-text">Your Match.</span>
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-2xl mx-auto">
              Find and book trusted, verified fitness professionals near
              you—with no faff, just fitness.
            </p>
            <div className="mt-8">
              <Link
                to="/"
                className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
              >
                Find a Professional
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="py-20 bg-gray-950">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              The Smarter Way to Train
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Find Verified Pros Nearby
                </h3>
                <p className="text-gray-400 text-center">
                  Use our interactive map and filters to discover trusted,
                  qualified professionals in your area.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 7V3m8 4V3m-9 8h.01M3 21h18a2 2 0 002-2V8.656a2 2 0 00-.606-1.424l-3.342-3.342A2 2 0 0013.586 3H10.414A2 2 0 009 5.828v2.172a2 2 0 00-.606 1.424l-3.342 3.342A2 2 0 003 16.344V21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Book Instantly
                </h3>
                <p className="text-gray-400 text-center">
                  No more back-and-forth messages. See your trainer's live
                  availability and book sessions instantly.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.687-6-6-6z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 12c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Secure Payments
                </h3>
                <p className="text-gray-400 text-center">
                  Pay securely in-app. No need to worry about cash, invoices, or
                  chasing down payments.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Reviews & Ratings
                </h3>
                <p className="text-gray-400 text-center">
                  Read real reviews from other clients to find the perfect
                  professional for your needs.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Guaranteed Trust
                </h3>
                <p className="text-gray-400 text-center">
                  All professionals on Fit-Match are verified for
                  qualifications, insurance, and ID.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Flexible Cancellation
                </h3>
                <p className="text-gray-400 text-center">
                  Life happens. Easily manage your bookings and cancellations
                  with our flexible policies.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Screenshots Section */}
        <section id="screenshots" className="py-20 bg-black">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-12">
              Fitness Made Simple
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-12">
              <div className="app-screenshot-frame -rotate-3 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage: "url('/images/screenshots/map-view.PNG')",
                  }}
                ></div>
              </div>
              <div className="app-screenshot-frame rotate-6 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/progress-track.png')",
                  }}
                ></div>
              </div>
              <div className="app-screenshot-frame -rotate-6 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/booking-flow.png')",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-20 bg-gray-950">
          <div className="container mx-auto px-6 text-center max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to find your match?
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed mb-8">
              Stop searching and start training. Your perfect fitness
              professional is just a tap away.
            </p>
            <Link
              to="/"
              className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
            >
              Get the App
            </Link>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 py-8 text-center text-gray-400">
        <p>&copy; 2024 Fit-Match. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ForClients;
